//
//
//
//
//
//

export default {
  name: "ChatIcon",
}
